import React, { createContext, useContext, useEffect, ReactNode } from 'react';
import { useCamera, UseCameraReturn } from '../hooks/useCamera';

const CameraContext = createContext<UseCameraReturn | undefined>(undefined);

export function CameraProvider({ children }: { children: ReactNode }) {
  const camera = useCamera();

  return <CameraContext.Provider value={camera}>{children}</CameraContext.Provider>;
}

export function useCameraContext() {
  const context = useContext(CameraContext);
  if (context === undefined) {
    throw new Error('useCameraContext must be used within a CameraProvider');
  }
  return context;
}
